import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useDashboard } from './useDashboard';
import { fetchJSON, AuthError } from '@/api/client';

export interface DispatchEntry { timestamp: string; active_dispatches: number; pending_callbacks: number; timed_out: number; }

export function useDispatches(hours = 6) {
  const { token, logout } = useAuth();
  const { refreshKey } = useDashboard();
  const [entries, setEntries] = useState<DispatchEntry[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    fetchJSON<{ entries?: DispatchEntry[] }>(`/api/dashboard/dispatches?hours=${hours}`, token)
      .then((d) => { if (!cancelled) { setEntries(d.entries || []); setLoading(false); } })
      .catch((e) => {
        if (e instanceof AuthError) { logout(); return; }
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [token, hours, refreshKey, logout]);

  return { entries, loading };
}
